import { logComponentError } from '@ms/yammer-data/dist/domains/diagnosticsDebugLogs/actions';
import type { MapDispatchToProps } from '@ms/yammer-data/dist/types';
import { connect } from 'react-redux';

import type { MappedDispatchProps } from './ErrorBoundary';
import ErrorBoundary from './ErrorBoundary';

export const mapDispatchToProps: MapDispatchToProps<MappedDispatchProps> = (dispatch) => ({
  logComponentError: (componentName, error) => dispatch(logComponentError(componentName, error)),
});

export default connect(null, mapDispatchToProps)(ErrorBoundary);
